export default __webpack_public_path__ + "static/media/goshen109.9c2763b5.jpg";